/**
 * 기사관리 전체검색 모달 ($j.Ui.JBModal.target 결합) — $j.F.Admin.Member.SearchModal
 *
 * /adm/members(기사관리)의 검색기능을 어느 관리자 페이지에서나 모달로 띄운다.
 * 서버사이드 DataTables 엔드포인트(POST /adm/ajax/members)를 그대로 재사용하되,
 * 좁은 모달 폭에 맞게 '통합검색 + 접이식 상세필터 + 핵심 컬럼' 으로 압축한 레이아웃.
 * 읽기전용(목록 조회) — 행 선택/콜백 없음.
 *
 * 여는 법 (전역 헬퍼 window.openMemberSearch 또는 직접):
 *   $j.Ui.JBModal.target('member-search-modal', {
 *       target: '$j.F.Admin.Member.SearchModal',
 *       title:  '기사 검색',
 *       width:  '960px',
 *   });
 *
 * 모든 DOM id 는 msq- 접두어로 네임스페이스한다.
 * (/adm/members 페이지 위에서 열려도 #table/#bsanum/#x9 등과 충돌하지 않도록)
 */
export default class SearchModal {
    constructor() {
        this.$root = null;
        this.$table = null;
        this.CAR = {}; // 차량옵션 선택 상태 (ct/cj/co/cr 원본)
    }

    init() {
        this.render();
        this.bindSosokPhone();
        this.bindEvents();
        this.initTable();
    }

    destroy() {
        if (this.$table) {
            try { this.$table.destroy(); } catch (e) { /* noop */ }
            this.$table = null;
        }
    }

    render() {
        const html = `
        <style>
            .msq { font-size:12px; }
            .msq .msq-adv { border:1px solid #e4e4e4; border-radius:5px; padding:10px; background:#fafafa; margin-bottom:8px; }
            .msq .msq-adv .msq-row { display:flex; flex-wrap:wrap; align-items:center; gap:6px 10px; margin-bottom:8px; white-space:nowrap; }
            .msq .msq-adv .msq-row:last-child { margin-bottom:0; }
            .msq .msq-adv label.chk { display:inline-flex; align-items:center; gap:3px; cursor:pointer; }
            .msq .msq-adv input[type=checkbox] { width:16px; height:16px; }
            .msq .msq-adv .sep { color:#ccc; }
            .msq .msq-adv select { height:30px; border:1px solid #ccc; border-radius:3px; }
            .msq .msq-adv input[type=text],
            .msq .msq-adv input[type=tel] { height:30px; border:1px solid #ccc; border-radius:3px; padding:2px 6px; }
            .msq .msq-adv .msq-car-btn { height:30px; padding:0 8px; border:1px solid #ccc; border-radius:3px; background:#fff; cursor:pointer; }
            .msq .msq-search-btn { height:30px; min-width:64px; background:#19ce60; color:#fff; border:none; border-radius:3px; cursor:pointer; font-weight:bold; }
            .msq .msq-search-btn:hover { background:#15b855; }
            .msq .msq-kwd { flex:1; min-width:280px; height:30px; padding:2px 8px; border:1px solid #bbb; border-radius:3px; background:#f2fbe4; }
            .msq .msq-car-memo { color:#0a2383; font-weight:bold; }
            .msq .msq-result { overflow-x:auto; }
            .msq table.msq-tbl { min-width:820px; width:100%; background:#fff; } /* 폰트사이즈는 ListTable(member-list-table) 단일관리 */
            .msq table.msq-tbl td, .msq table.msq-tbl th { white-space:nowrap; }
        </style>
        <div class="msq">
            <div class="msq-adv" id="msq-adv">
                <div class="msq-row">
                    <label class="chk"><input type="checkbox" id="msq-chk-all">전체</label>
                    <label class="chk"><input type="checkbox" class="msq-opt-chk" value="A" data-value="스카이">스카이</label>
                    <label class="chk"><input type="checkbox" class="msq-opt-chk" value="B" data-value="사다리">사다리</label>
                    <label class="chk"><input type="checkbox" class="msq-opt-chk" value="C" data-value="크레인">크레인</label>
                    <label class="chk"><input type="checkbox" class="msq-opt-chk" value="D" data-value="지게차">지게차</label>
                    <label class="chk"><input type="checkbox" class="msq-opt-chk" value="E" data-value="굴삭기">굴삭기</label>
                    <label class="chk"><input type="checkbox" class="msq-opt-chk" value="F" data-value="리프트">리프트</label>
                    <span class="sep">|</span>
                    <button type="button" class="msq-car-btn" id="msq-car">차량옵션</button>
                    <input type="text" id="msq-x4" style="width:110px" placeholder="차고지검색">
                    <span class="msq-car-memo" id="msq-car-memo"></span>
                </div>
                <div class="msq-row">
                    <label class="chk"><input type="checkbox" class="msq-opt-chk" value="G">소유자만</label>
                    <label class="chk"><input type="checkbox" class="msq-opt-chk" value="H">선불결제</label>
                    <label class="chk"><input type="checkbox" class="msq-opt-chk" value="I">장기감면</label>
                    <label class="chk"><input type="checkbox" class="msq-opt-chk" value="J"> -6차</label>
                    <label class="chk"><input type="checkbox" class="msq-opt-chk" value="K">부재중</label>
                    <label class="chk"><input type="checkbox" class="msq-opt-chk" value="M">서류</label>
                    <label class="chk"><input type="checkbox" class="msq-opt-chk" value="L">테스트제외</label>
                </div>
                <div class="msq-row">
                    본사 <select id="msq-bsanum"><option value="">선택</option></select>
                    지사 <select id="msq-gsanum"><option value="">선택</option></select>
                    센터 <select id="msq-cntnum"><option value="">선택</option></select>
                    <span class="sep">|</span>
                    상태 <select id="msq-x2" style="background:lightsteelblue">
                        <option value="SA">전체</option>
                        <option value="S0" selected>등록</option>
                        <option value="S1">대기</option>
                        <option value="S98">탈퇴신청</option>
                        <option value="S99">탈퇴</option>
                    </select>
                    유형 <select id="msq-x3">
                        <option value="">선택</option>
                        <option value="수발주자">수발주자</option>
                        <option value="업체발주자">업체발주자</option>
                        <option value="발주자">발주자</option>
                    </select>
                    미접속 <select id="msq-x5">
                        <option value="">선택</option>
                        <option value="7">1주↑</option>
                        <option value="30">1달↑</option>
                        <option value="90">3달↑</option>
                        <option value="365">1년↑</option>
                    </select>
                </div>
                <div class="msq-row">
                    <input type="text" id="msq-x6" style="width:90px" placeholder="기사코드">
                    <input type="text" id="msq-x7" style="width:90px" placeholder="소유자코드">
                    <input type="text" id="msq-x8" class="han" style="width:90px;ime-mode:active" placeholder="기사명">
                    <button type="button" class="msq-search-btn" id="msq-search"><i class="fas fa-search"></i> 검색</button>
                    <span class="sep">|</span>
                    <input type="tel"  id="msq-x9" style="width:120px" placeholder="전화번호">
                    <input type="text" class="msq-kwd" id="msq-xb" autocomplete="off"
                           placeholder="통합검색 (기사코드, 기사명, 전화번호, 상호, 대표자)">
                </div>
            </div>

            <div class="msq-result">
                <table id="msq-table" class="table table-bordered display msq-tbl"></table>
            </div>
        </div>`;

        $(`#${this.id}`).html(html);
        this.$root = $(`#${this.id}`);
    }

    /** 소속 cascade + 전화번호 입력 핸들러 ($j.Common.Form 공용 헬퍼) */
    bindSosokPhone() {
        const F = $j.Common.Form;
        F.registerPhoneHandler('msq-x9');
        F.registerBonsaHandler('msq-bsanum', 'msq-gsanum', 'msq-cntnum');
        F.registerGisaHandler('msq-gsanum', 'msq-cntnum');
        F.updateBonsaSelectBox('', 'msq-bsanum', 'msq-gsanum', 'msq-cntnum');
    }

    bindEvents() {
        const self = this;
        const $r = this.$root;

        // 검색 (기사명 옆 버튼)
        $r.find('#msq-search').on('click', () => self.reload());
        $r.find('input[type=text], input[type=tel]').on('keydown', function (e) {
            if (e.keyCode === 13) { e.preventDefault(); self.reload(); }
        });

        // 업종 전체 체크
        $r.find('#msq-chk-all').on('click', function () {
            self.checkAllCarTypes($(this).prop('checked'));
        });
        $r.find('.msq-opt-chk').on('click', function () {
            if (['A', 'B', 'C', 'D', 'E', 'F'].includes($(this).val())) {
                $r.find('#msq-chk-all').prop('checked', false);
            }
        });

        // 차량옵션 모달 (기존 CarSelect 재사용)
        $r.find('#msq-car').on('click', () => self.openCarModal());
    }

    /**
     * 업종(A~F) 체크박스 일괄 제어.
     * only(한글 업종명, CarSelect.getCarType() 반환값)가 있으면 전체 해제 후 data-value 로 해당 업종만 체크.
     */
    checkAllCarTypes(checked, only) {
        const $r = this.$root;
        ['A', 'B', 'C', 'D', 'E', 'F'].forEach((v) => {
            $r.find(`.msq-opt-chk[value="${v}"]`).prop('checked', checked);
        });
        if (only) $r.find(`.msq-opt-chk[data-value="${only}"]`).prop('checked', true);
    }

    /**
     * DataTables 초기화 — 기사관리(/adm/members)와 동일한 공용 모듈을 쓰되,
     * 좁은 모달 폭에 맞게 표시 컬럼만 축소한다. (렌더 로직은 ListTable 공유)
     */
    initTable() {
        const self = this;
        this.$table = $j.F.Admin.Member.ListTable.create({
            selector:  '#msq-table',
            // 소유자 칸은 없앴다 — 소속자만 이름 옆 아이콘으로 표시된다 (ListTable)
            columns:   ['no', 'carType', 'bonsa', 'gisa', 'phone', 'name', 'car'],
            getSearch: () => self.buildSearch(),
            pageLength: 15,
        });
    }

    reload() {
        if (this.$table) this.$table.ajax.reload();
    }

    /** 검색조건 수집 → 엔드포인트 파라미터 (opt/x1~xb/ct·cj·co·cr) */
    buildSearch() {
        const $r = this.$root;
        const val = (id) => ($r.find('#' + id).val() || '').trim();

        // 체크옵션(A~F 업종 + G~M 옵션)을 하나의 opt 문자열로
        let opt = '';
        $r.find('.msq-opt-chk:checked').each(function () { opt += $(this).val(); });

        // 소속: 센터 > 지사 > 본사 우선
        const x1 = val('msq-cntnum') || val('msq-gsanum') || val('msq-bsanum');

        return {
            opt,
            x1,
            x2: val('msq-x2'),
            x3: val('msq-x3'),
            x4: val('msq-x4'),
            x5: val('msq-x5'),
            x6: val('msq-x6'),
            x7: val('msq-x7'),
            x8: val('msq-x8'),
            x9: val('msq-x9'),
            xb: val('msq-xb'),
            ct: this.CAR.car_type || '',
            cr: this.CAR.car_range || '',
            cj: this.CAR.jungo || '',
            co: this.CAR.option || '',
        };
    }

    /** 차량 검색 설정 — 기사관리(/adm/members)와 같은 공용 모달을 쓴다 */
    openCarModal() {
        const self = this;
        $j.F.Admin.Member.CarSearchModal.open({
            car: self.CAR,
            onApply(data) {
                self.checkAllCarTypes(false, data.car_type);   // 고른 기종의 업종 체크박스 동기화
                self.$root.find('#msq-car-memo').html($j.F.Admin.Member.CarSearchModal.memo(data));
                self.CAR = data;
                self.reload();
            },
            onClear() {
                self.CAR = {};
                self.checkAllCarTypes(false);
                self.$root.find('#msq-car-memo').html('');
                self.reload();
            },
        });
    }
}
